import { useDebounce } from 'use-debounce'

/**
 * Returns `active` debounced by `delay` ms. Use to gate validation banners
 * off rapidly-changing form state so they do not flash on every keystroke
 * before the user has stopped editing.
 *
 * Thin wrapper around `useDebounce` so call sites read as intent ("show
 * this banner after the error sticks") rather than mechanics.
 */
export function useDebouncedFlag(active: boolean, delay = 500): boolean {
  const [debounced] = useDebounce(active, delay)
  return debounced
}
